const AUTH_KEY = 'menbirinchi_auth';

export function normalizeName(name) {
  return String(name || '')
    .trim()
    .replace(/\s+/g, ' ');
}

export function namesEqual(a, b) {
  return normalizeName(a).toLowerCase() === normalizeName(b).toLowerCase();
}

export function loadAuth() {
  try {
    const raw = localStorage.getItem(AUTH_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (
      !data ||
      data.roomID == null ||
      data.playerID == null ||
      !data.credentials
    ) {
      return null;
    }
    return {
      playerID: String(data.playerID),
      credentials: data.credentials,
      roomID: String(data.roomID).toUpperCase(),
      name: data.name || '',
      hostConfig: data.hostConfig || null,
    };
  } catch (e) {
    return null;
  }
}

export function saveAuth(auth) {
  try {
    if (!auth || auth.roomID == null || auth.playerID == null || !auth.credentials) {
      return;
    }
    localStorage.setItem(
      AUTH_KEY,
      JSON.stringify({
        playerID: String(auth.playerID),
        credentials: auth.credentials,
        roomID: String(auth.roomID).toUpperCase(),
        name: auth.name || '',
        hostConfig: auth.hostConfig || null,
        savedAt: Date.now(),
      })
    );
  } catch (e) {
    // private mode / quota
  }
}

export function clearAuth() {
  try {
    localStorage.removeItem(AUTH_KEY);
  } catch (e) {
    // ignore
  }
}

/** Saved session for this room (by roomID + playerID in localStorage) */
export function loadAuthForRoom(roomID) {
  const auth = loadAuth();
  if (!auth || !roomID) return null;
  if (String(auth.roomID).toUpperCase() !== String(roomID).toUpperCase()) {
    return null;
  }
  return auth;
}
